<template>
  <b-field
    :label="$t('compCoreDomainInput.label-1') + ' *'"
    :type="{ 'is-danger': errors.has('domains') }"
    :message="errors.first('domains')"
  >
    <b-taginput
      field="name"
      name="domains"
      icon="hubzilla"
      :data="filteredDomains"
      :allow-new="false"
      v-validate="'required'"
      rounded
      v-model="buffer"
      :placeholder="$t('compCoreDomainInput.label-2')"
      :open-on-focus="true"
      :loading="loading"
      :disabled="loading"
      @input="inputChanged"
      @typing="getFilteredDomains"
      @select="selectDomain"
      autocomplete
      clearable
    >
      <template slot-scope="props">
        {{ props.option.name }}
      </template>
    </b-taginput>
  </b-field>
</template>

<script>
import coreService from '@/services/coreService'

export default {
  name: 'DomainInput',
  inject: ['$validator'],
  props: {
    value: {
      type: Array,
      default: function () {
        return {
          id: null,
          name: ''
        }
      }
    }
  },
  emits: ['input', 'onDisciplineChange'],
  data () {
    return {
      loading: true,
      domains: [],
      filteredDomains: [],
      buffer: Object.assign([], this.value)
    }
  },
  methods: {
    getFilteredDomains (text) {
      this.filteredDomains = this.domains.filter((option) => {
        return (
          option.name.toString().toLowerCase().indexOf(text.toLowerCase()) >= 0
        )
      })
    },
    selectDomain (option) {
      if (option) {
        this.buffer.id = option.id
        this.buffer.name = option.name
      }
    },
    inputChanged () {
      if (this.loading) {
        // ignore everything while the list of domains isn't fully loaded
        return
      }
      if (
        this.filteredDomains.length === 1 &&
        this.filteredDomains[0].name === this.buffer.name
      ) {
        this.buffer.id = this.filteredDomains[0].id
        this.buffer.name = this.filteredDomains[0].name
      } else {
        this.buffer.id = null
      }
      this.$emit('input', this.buffer)
      this.$emit('onDisciplineChange', this.buffer)
    }
  },
  watch: {
    value: {
      handler () {
        this.buffer = Object.assign([], this.value)
      },
      deep: true
    }
  },
  created () {
    coreService.getDomains().then((data) => {
      this.domains = data
      this.filteredDomains = data
      // this will make sure the list of domains is loaded prior to anything
      // else. Since this is run in the background, there's might be a race
      // condition because the parent (MyLaboratory) fill in the saved
      // discipline in the input triggering a call to the inputChanged method.
      // If called too early this method will find no corresponding discipline
      // and will set the id to null (this will be interpreted as an error in
      // the parent component)
      this.loading = false
    })
  }
}
</script>
